import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-finish-poh-scan',
  templateUrl: './finish-poh-scan.component.html',
  styleUrls: ['./finish-poh-scan.component.css']
})
export class FinishPohScanComponent implements OnInit {
    webPageName;

    public labourNameButtons: FormButton[] = [{ id: 'search', type: 'primary', icon: 'fas fa-search', goto: 'selectlabourpu', gotoParms: () => this.webPageName ?? '' }];

    public operationNameButtons: FormButton[] = [{ id: 'search', type: 'primary', icon: 'fas fa-search', goto: 'selectoperationpu', gotoParms: () => this.webPageName ?? '' }];
    
    public equipmentNameButtons: FormButton[] = [{
        id: 'search',
        type: 'primary',
        icon: 'fas fa-search',
        goto: 'selectequipmentpu',
        gotoParms: () => ({
            webpagename: this.webPageName,
            operation_id: this.setting!.operation_id
        })
    }];

    public barcodeButtons: FormButton[] = [{ id: 'search', icon: 'fas fa-search', type: 'primary', onClick: () => this.retrieveProductionOrder() }];

    public setting?: Setting;

    public barcode: string = '';

    public itemsListStockBatchLasts: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.webPageName = this.stateService.getCurrentName();
    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(194))[0];
    }

    private async loadStockBatchLasts() {
        if (!this.setting) return;

        return this.itemsListStockBatchLasts = await this.datatask.Post(2469, this.setting);
    }

    public async retrieveProductionOrder() {
        if (!this.barcode) return;

        try {
            const response = (await this.datatask.Post(154, { barcode: this.barcode }))[0];

            if (response) {
                if (response?.barcodetype === 'LA') {
                    this.loadSetting();
                } else if (response?.barcodetype === 'PO' || response?.barcodetype === 'PT') {
                    this.stateService.go(response?.webpagename, response?.parms);
                }
            }
        } finally {
            this.barcode = '';
        }
    }

    public searchOrScanProductionOrder() {
        this.retrieveProductionOrder();
    }

    private async init() {
        await this.loadSetting();

        // Redirecting to a new webpage if webpagename has value
        if (this.setting!.webpagename > '') this.stateService.go(this.setting!.webpagename, { webpagename: this.webPageName });
        if (this.setting!.show_last_produced_stockbatches === '1') return this.loadStockBatchLasts();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    labour_no: string;
    labour_name: string;
    webpagename: string;
    webpage_parameters: string;
    operation_id: string;
    operation_name: string;
    show_setting: string;
    equipment_id: string;
    equipment_name: string;
    show_equipment: string;
    stockplace_id: string;
    stockplace_name: string;
    show_paperless: string;
    show_stockplace: string;
    show_barcode: string;
    show_last_produced_stockbatches: string;
}
